import { render, staticRenderFns } from "./template10.vue?vue&type=template&id=17f9e942&scoped=true"
import script from "./template10.vue?vue&type=script&lang=js"
export * from "./template10.vue?vue&type=script&lang=js"
import style0 from "./template10.vue?vue&type=style&index=0&id=17f9e942&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f9e942",
  null
  
)

export default component.exports